import type { ShippingMethods } from "@store/types";

import type { MagentoApiGetShippingMethodsQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";
import { normalizeShippingMethods } from "../utils";

export const getShippingMethodsEndpoint = (builder: MagentoApiBuilder) => ({
  getShippingMethods: builder.query<ShippingMethods, string>({
    query: (cartId) => ({
      method: "getShippingMethods",
      params: [{ cartId }],
    }),
    transformResponse: (response: MagentoApiGetShippingMethodsQueryResponse) =>
      normalizeShippingMethods(response.cart?.shipping_addresses?.[0]),
    providesTags: [TAGS.SHIPPING_METHODS],
  }),
});
